import { render, staticRenderFns } from "./serach_header.vue?vue&type=template&id=671ae8ae&"
import script from "./serach_header.vue?vue&type=script&lang=js&"
export * from "./serach_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports